/**
 * Created by r4zi4l on 24.08.2021
 */

const OrderDetails = cc.Node.extend({
    ctor: function (orders) {
        this._super();

        this.orders = orders;
        this.maker = orders.getCurrentMaker();

        this.setContentSize2(cleverapps.styles.OrderDetails);

        this.createContent();
        this.setLocalZOrder(-1);

        this.orders.on("makerSelected", this.updateMaker.bind(this), this);
        this.orders.on("orderStateChanged", this.updateOrder.bind(this), this);
        this.orders.on("orderStateChanged", this.updateIngredients.bind(this), this);
    },

    createContent: function () {
        const styles = cleverapps.styles.OrderDetails;

        this.person = this.createPerson();
        this.dialogue = this.createDialogue();

        const table = this.table = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.details_table, cleverapps.UI.Scale9Rect.Default);
        table.setContentSize2(styles.table);
        table.setAlignment(styles.table);
        table.setLocalZOrder(1);
        this.addChild(table);

        if (this.maker) {
            this.timer = this.createTimer();
            this.hungryTimer = this.createHungryTimer();

            this.ingredients = new IngredientsList(this.maker);
            table.addChild(this.ingredients);
        }

        this.button = this.createButton();
    },

    createPerson: function () {
        const styles = cleverapps.styles.OrderDetails.person;
        const frames = bundles.orders_portraits.frames;

        const role = this.maker && this.maker.unit.code || "dwarf";

        const person = new cc.Sprite(frames[role] || frames.dwarf);
        person.setAnchorPoint(0.5, 0);
        this.addChild(person);

        person.setAlignment(styles);

        person.originalPosition = person.getPosition();

        return person;
    },

    createDialogue: function () {
        const styles = cleverapps.styles.OrderDetails.dialogue;

        let title, rewards;
        if (this.maker) {
            title = cleverapps.UI.generateOnlyText(Messages.get("Rewards.list"), cleverapps.styles.FONTS.ORDERDETAILS_DIALOGUE_TEXT);
            title.fitTo(styles.content.width);

            const orderUnits = this.maker.recipe.order.reduce((acc, item) => {
                for (let i = 0; i < item.amount; i++) {
                    acc.push({ unit: item.unit });
                }
                return acc;
            }, []);

            const icons = orderUnits.map((item) => {
                const icon = UnitView.getUnitImage(item.unit);
                icon.setAnchorPoint(0.5, 0);
                return icon;
            });

            const provider = this.maker.unit.components.find((component) => component.getOrderRewards);
            if (provider && provider.getOrderRewards()) {
                new RewardsList(provider.getOrderRewards(), { event: cleverapps.EVENTS.EARN.OTHER }).listRewards().forEach((reward) => {
                    const icon = reward.getIcon();
                    icon.setAnchorPoint(0.5, 0);
                    icons.push(icon);
                });
            }

            rewards = new cleverapps.Layout(icons, {
                direction: cleverapps.UI.HORIZONTAL
            });
            cleverapps.UI.fitToBox(rewards, {
                width: styles.content.width,
                maxScale: 1.2
            });
        } else {
            title = cleverapps.UI.generateOnlyText(Messages.get("OrdersWindow.dialoguePlaceholder"), cleverapps.styles.FONTS.ORDERDETAILS_DIALOGUE_PLACEHOLDER_TEXT);
            title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
            title.setDimensions(styles.content.width, 0);
            title.fitTo(undefined, styles.content.height);
        }

        const content = new cleverapps.Layout([title, rewards].filter(Boolean), {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.content.margin
        });

        const background = cleverapps.UI.createScale9Sprite(bundles.dialogues.frames.bg_minimal_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(content.width * content.scaleX + styles.padding.left + styles.padding.right, content.height * content.scaleY + styles.padding.top + styles.padding.bottom);
        background.setAnchorPoint(0.5, 0.5);
        background.setAlignment(styles);
        this.addChild(background);

        content.setAnchorPoint(0, 0);
        content.setAlignment(styles.padding.left, styles.padding.bottom);
        background.addChild(content);

        return background;
    },

    createTimer: function () {
        const styles = cleverapps.styles.OrderDetails.timer;

        if (!this.maker || this.maker.unit.findComponent(HungryGamesCustomer)) {
            return new cc.Node();
        }

        let countdown;
        if (this.maker.getState() === Customer.STATE_COOKING) {
            countdown = new cleverapps.CountDown(this.maker.getCookingTimeLeft());
        } else if (this.maker.getState() === Customer.STATE_RECIPE) {
            countdown = this.maker.recipe.cookingDuration;
        } else {
            countdown = 0;
        }

        const background = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.details_timer, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles);
        background.setAnchorPoint(0.5, 0.5);
        background.setAlignment(styles);
        this.table.addChild(background);

        const text = new cleverapps.CountDownView(countdown, {
            font: cleverapps.styles.FONTS.ORDERDETAILS_TIMER_TEXT
        });
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        background.addChild(text);

        return background;
    },

    createHungryTimer: function () {
        const hungryGamesCustomer = this.maker.unit.findComponent(HungryGamesCustomer);

        if (!hungryGamesCustomer || !hungryGamesCustomer.hasLevelTimer() || this.maker.getState() !== Customer.STATE_RECIPE) {
            return undefined;
        }

        const styles = cleverapps.styles.OrderDetails.hungryTimer;

        const background = cleverapps.UI.createScale9Sprite(bundles.orderswindow.frames.details_timer_hungry, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setContentSize2(styles);
        background.setAnchorPoint(0.5, 0.5);
        background.setAlignment(styles);
        this.addChild(background);

        const text = new cleverapps.CountDownView(new cleverapps.CountDown(hungryGamesCustomer.getTimeLeft()), {
            font: cleverapps.styles.FONTS.ORDERDETAILS_HUNGRY_TIMER_TEXT
        });
        text.setAnchorPoint(0.5, 0.5);
        text.setAlignment(styles.text);
        background.addChild(text);

        return background;
    },

    createButton: function () {
        const styles = cleverapps.styles.OrderDetails.button;

        let button;
        if (!this.maker || this.maker.getState() === Customer.STATE_EMPTY) {
            button = new cleverapps.UI.Button({
                width: styles.width,
                height: styles.height,
                text: Messages.get("OrdersWindow.button.make"),
                disabled: true,
                onClicked: function () {}
            });
        } else if (this.maker.getState() === Customer.STATE_RECIPE) {
            const hungryGamesCustomer = typeof HungryGamesCustomer !== "undefined" && this.maker.unit.findComponent(HungryGamesCustomer);
            button = new cleverapps.UI.Button({
                width: styles.width,
                height: styles.height,
                text: this.maker.canCook() || hungryGamesCustomer ? Messages.get("OrdersWindow.button.make") : this.orders.getBuyIngredientsText(this.maker),
                disabled: Boolean(!this.maker.canCook() && hungryGamesCustomer),
                onClicked: this.onButtonClick.bind(this)
            });
        } else if (this.maker.getState() === Customer.STATE_READY) {
            button = new cleverapps.UI.Button({
                width: styles.width,
                height: styles.height,
                text: Messages.get("Claim"),
                onClicked: this.onButtonClick.bind(this)
            });
        } else if (this.maker.getState() === Customer.STATE_COOKING) {
            const buttonOptions = {
                canCoins: true,
                price: Unit.CalcSpeedUPPrice(this.maker.getCookingTimeLeft()),
                freeIcon: TextWithIcon.ICONS_BY_NAME.speedup,
                onClicked: this.onButtonClick.bind(this),
                eventName: cleverapps.EVENTS.SPENT.ORDER,
                speedUp: true,
                type: cleverapps.styles.UI.Button.Images.button_blue,
                width: styles.width,
                height: styles.height
            };

            if (this.maker.recipe && this.maker.recipe.cookingDuration && ConfirmSpeedUpWindow.isAvailable(buttonOptions.price)) {
                buttonOptions.confirmWindowOptions = {
                    timeLeft: this.maker.getCookingTimeLeft(),
                    totalDuration: this.maker.recipe.cookingDuration
                };
            }

            button = new UseGoldButton(buttonOptions);
        }

        button.setAlignment(styles);
        this.table.addChild(button);

        if (Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() || this.maker && this.maker.getState() === Customer.STATE_READY) {
            button.runAction(new cc.Sequence(
                new cc.DelayTime(Map2dLocation.currentLocation.tutorial.isActive() || cleverapps.tutorial.isActive() ? 0.3 : 2.5),
                new cc.CallFunc(() => {
                    FingerView.hintTap(button, {
                        delay: 2.5,
                        repeatDelay: 2.5
                    });
                })
            ));
        }

        return button;
    },

    getHidePosition: function () {
        const originalPosition = this.person.originalPosition;
        return cc.p(originalPosition.x + cleverapps.styles.OrderDetails.person.hidedX, originalPosition.y);
    },

    showPerson: function () {
        this.person.stopAllActions();
        this.person.setAlignment(this.getHidePosition(this.person));
        this.person.setVisible(false);
        this.person.runAction(new cc.Sequence(
            new cc.DelayTime(0.35),
            new cc.Show(),
            new cc.MoveTo(0.3, this.person.originalPosition).easing(cc.easeBackOut())
        ));
    },

    hidePerson: function () {
        this.person.stopAllActions();

        this.person.runAction(new cc.Sequence(
            new cc.MoveTo(0.3, this.getHidePosition(this.person)).easing(cc.easeBackIn()),
            new cc.RemoveSelf()
        ));
    },

    changePerson: function () {
        this.person.stopAllActions();
        this.hidePerson();
        this.person = this.createPerson(this.maker);
        this.showPerson();
    },

    changeDialogue: function () {
        this.dialogue.stopAllActions();
        this.dialogue.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, 0.1),
            new cc.RemoveSelf()
        ));
        this.dialogue = this.createDialogue(this.maker);
        this.dialogue.setVisible(false);
        this.dialogue.runAction(new cc.Sequence(
            new cc.DelayTime(0.6),
            new cc.ScaleTo(0, 0.1),
            new cc.Show(),
            new cc.ScaleTo(0.15, 1)
        ));
    },

    changeButton: function () {
        this.button.stopAllActions();
        this.button.disable();
        this.button.runAction(new cc.Sequence(
            new cc.ScaleTo(0.15, 0.1),
            new cc.RemoveSelf()
        ));
        this.button = this.createButton(this.maker);
        this.button.setVisible(false);
        this.button.setScale(0.1);
        this.button.runAction(new cc.Sequence(
            new cc.DelayTime(0.15),
            new cc.Show(),
            new cc.ScaleTo(0.15, 1)
        ));
    },

    changeTimer: function () {
        if (this.timer) {
            this.timer.removeFromParent();
            this.timer = undefined;
        }

        if (this.maker) {
            this.timer = this.createTimer(this.maker);
        }
    },

    changeHungryTimer: function () {
        if (this.hungryTimer) {
            this.hungryTimer.removeFromParent();
            this.hungryTimer = undefined;
        }

        if (this.maker) {
            this.hungryTimer = this.createHungryTimer();
        }
    },

    changeIngredients: function () {
        if (this.ingredients) {
            this.ingredients.removeAnimated();
            this.ingredients = undefined;
        }

        if (this.maker) {
            this.ingredients = new IngredientsList(this.maker);
            this.table.addChild(this.ingredients);
            this.ingredients.showAnimated();
        }
    },

    updateMaker: function (maker) {
        if (maker === this.maker) {
            return;
        }
        this.maker = maker;

        this.changePerson();
        this.changeButton();
        this.changeDialogue();
        this.changeTimer();
        this.changeHungryTimer();
        this.changeIngredients();
    },

    updateOrder: function (maker) {
        if (this.maker === maker) {
            this.changeButton();
            this.changeTimer();
            this.changeHungryTimer();
        }
    },

    updateIngredients: function () {
        const canCook = this.maker && this.maker.canCook();
        if (this.canCook !== canCook) {
            this.canCook = canCook;
            this.changeButton();
        }

        if (this.ingredients) {
            this.ingredients.updateAmounts();
        }
    },

    onButtonClick: function () {
        this.orders.processOrder(this.maker);
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    ORDERDETAILS_TIMER_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    ORDERDETAILS_HUNGRY_TIMER_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    ORDERDETAILS_DIALOGUE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    ORDERDETAILS_DIALOGUE_PLACEHOLDER_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    }
});

cleverapps.styles.OrderDetails = {
    width: 640,
    height: 900,

    table: {
        width: 640,
        height: 410,
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 0 }
    },

    person: {
        hidedX: -450,
        x: { align: "center", dx: -155 },
        y: { align: "bottom", dy: 370 }
    },

    dialogue: {
        x: { align: "left", dx: 260 },
        y: { align: "bottom", dy: 585 },

        padding: {
            left: 60,
            right: 33,
            top: 20,
            bottom: 26
        },

        content: {
            width: 280,
            height: 250,
            margin: 5
        }
    },

    timer: {
        x: { align: "center", dx: 160 },
        y: { align: "center", dy: 236 },
        width: 290,
        height: 100,

        text: {
            x: { align: "center", dx: -2 },
            y: { align: "center", dy: 9 }
        }
    },

    hungryTimer: {
        x: { align: "center", dx: -160 },
        y: { align: "top", dy: -4 },
        width: 340,
        height: 140,

        text: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        }
    },

    button: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -96 },
        width: 260,
        height: 86,
        padding: {
            left: 24,
            right: 24,
            top: 5,
            bottom: 5
        },
        margin: 4
    }
};
